<template>
  <div>
    <v-container>
      <v-row>
        <v-col>
          <ValidationObserver ref="obs">
            <form @submit.prevent="submit()" ref="form">
              <h2>{{$t("app.my_profile")}}</h2>
              <v-alert v-if="error" outlined color="red">{{error}}</v-alert>

              <ValidationProvider name="Name" rules="required|max:30">
                <v-text-field
                  slot-scope="{
                errors,
                valid
              }"
                  :error-messages="errors"
                  :success="valid"
                  v-validate="'required'"
                  v-model="user.name"
                  :label="$t('app.company_name')"
                  required
                ></v-text-field>
              </ValidationProvider>
              <ValidationProvider name="Address" rules="required">
                <v-textarea
                  slot-scope="{
                errors,
                valid
              }"
                  :error-messages="errors"
                  :success="valid"
                  v-validate="'required'"
                  v-model="user.address"
                  :label="$t('app.address')"
                ></v-textarea>
              </ValidationProvider>

              <v-textarea v-model="user.details" :label="$t('app.details')"></v-textarea>

              <v-text-field disabled label="Email"   :value="$store.state.user.email"></v-text-field>
              <v-select v-model="user.language"
              chips
                        :items="$t('app.profile_language')"
                        :label="$t('app.preferred_language')"
                        item-text="title"
                        item-value="key">
              </v-select>
              <v-row>
                <v-col></v-col>
                <v-col>
                  <v-btn
                    block
                    color="primary"
                    type="submit"
                    :loading="$store.state.fetching"
                  >{{$t('app.update')}}</v-btn>
                </v-col>
              </v-row>
            </form>
          </ValidationObserver>
        </v-col>
        <v-col>
           <v-avatar size="100">
              <img :src="user.logo" />
            </v-avatar>

             <v-file-input
            accept="image/*"
            chips
            show-size
            @change="onFilePicked"
            :label="$t('app.your_logo')"
          ></v-file-input>

        </v-col>
      </v-row>
    </v-container>
  </div>
</template>
<script>
import { db } from "../../firebase";
import { firebase } from "@firebase/app";
import "@firebase/firestore";
import "@firebase/auth";
import { mapActions } from "vuex";
import { ValidationObserver, ValidationProvider } from "vee-validate";
import i18n from "../../plugins/i18n";

export default {
  name: "Profile",
  components: { ValidationObserver, ValidationProvider },
  data() {
    return {
      error: "",
      user: { name: "", details :"" }
    };
  },
  mounted(){
       db.collection("users").doc(this.$store.state.user.uid)
        .get()
        .then(r => {
         this.user = r.data()
        }).catch(err => {console.log(err.message)})
  },
  methods: {
       ...mapActions(["prevStep","toogleFetching","setUserProfile"]),
    async submit() {
      const result = await this.$refs.obs.validate();
      const user_id = firebase.auth().currentUser.uid;
      this.user.user_id = user_id;
      this.user.email = this.$store.state.user.email
      i18n.locale = this.user.language;
      if (result) {
        db.collection("users")
          .doc(user_id)
          .set(this.user)
          .then(() => this.setUserProfile(this.user))
          .catch(err => console.log(err.message));
      }
    },
    onFilePicked(e) {
      if (e.size > 0) {
        this.imageName = e.name;
        if (this.imageName.lastIndexOf(".") <= 0) { 
          return;
        }
        const fr = new FileReader();
        fr.readAsDataURL(e);
        fr.addEventListener("load", () => {
           this.toogleFetching()
          this.imageFile = e; // this is an image file that can be sent to server...
          var storageRef = firebase.storage().ref();
          var mountainsRef = storageRef.child(`images/${this.imageName}`);
          mountainsRef.put(this.imageFile).then(snapshot => {
            snapshot.ref.getDownloadURL().then(downloadURL => {
               this.toogleFetching()
              this.user.logo = downloadURL;
            });
          });
        });
      } else {
        this.imageName = "";
        this.imageFile = "";
        this.imageUrl = "";
      }
    }
  }
};
</script>

<style scoped>
</style>